module.exports = __webpack_public_path__ + "static/media/home-hero--bg-southafrica.3f8466bb.jpg";